module.exports = __webpack_public_path__ + "img/img-db0529.png";